import { OrdersState } from "../reducer/state";
import { useAppState } from "../../../appState";

export default function useOrdersState(): OrdersState {
	return useAppState().orders;
}
